import { ReactNode } from "react";

import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives/responsive";

const tabVerticalWrapper = css({
    display: "flex",
    flexDirection: "column"
});
const tabTextWrapper = css({
    "display": "flex",
    "alignItems": "center",

    [media.below.sm]: {
        paddingBlock: 12,
        paddingInlineStart: 2,
        paddingInlineEnd: 4
    },
    [media.above.sm]: {
        paddingBlock: 16,
        paddingInlineStart: 4,
        paddingInlineEnd: 8
    },

    ":hover": {
        color: "#0052CC",

        h4: {
            color: "#0052CC"
        }
    }
});

const selectedTabStyle = css({
    color: "#0052CC",
    h4: {
        color: "#0052CC"
    }
});

const titleStyle = css({
    marginBlock: 0,

    [media.below.sm]: {
        marginInlineStart: 8
    },
    [media.above.sm]: {
        marginInlineStart: 16
    }
});

const lozengeStyle = css({
    marginInlineStart: 8,
    borderRadius: 3,
    backgroundColor: "#E9F2FE",
    color: "#1558BC",
    paddingInline: 4,
    textTransform: "uppercase",
    fontSize: "0.6875rem",
    lineHeight: "1rem",
    fontWeight: 500,
    verticalAlign: "middle"
});

const underline = css({
    display: "flex",
    height: 4,
    borderRadius: 2
});

const selectedUnderline = css({
    backgroundColor: "#0052CC"
});

export type IconTabsProps = {
    isSelected?: boolean;
    icon: ReactNode;
    title: string;
    lozenge?: string;
};

export const IconTab = ({
    isSelected,
    icon,
    title,
    lozenge
}: IconTabsProps) => {
    return (
        <div css={tabVerticalWrapper}>
            <div css={[tabTextWrapper, isSelected && selectedTabStyle]}>
                {icon}
                <h4 css={titleStyle}>
                    {title}
                    {lozenge && <span css={lozengeStyle}>{lozenge}</span>}
                </h4>
            </div>
            <div css={[underline, isSelected && selectedUnderline]} />
        </div>
    );
};
